export const getCoveredAreasListData = ({ state }) => state.coveredAreas.areasList;
export const getSelectedAreasIds = ({ state }) => state.coveredAreas.selectedAreasIds;
export const getLoadingState = ({ state }) => state.coveredAreas.loading;
export const getIsDisabled = ({ state }) => state.coveredAreas.isDisabled;
